import React from 'react';
import { CTAButton } from './CTAButton';
export const BeforeAfter = () => {
  return <div className="py-8 bg-white rounded-lg shadow-sm p-6 my-8" data-id="element-19">
      <h2 className="text-3xl font-bold mb-6 text-green-700" data-id="element-20">
        Min förvandlingsresa - både inuti och utanpå
      </h2>
      <p className="text-lg mb-6" data-id="element-21">
        Jag började ta Nourix i slutet av januari, och ärligt talat förväntade
        jag mig inte mycket. De första dagarna märkte jag ingen skillnad alls,
        och jag tänkte "här går vi igen, ännu en produkt som lovar för mycket".
      </p>
      <p className="text-lg mb-6" data-id="element-22">
        Men efter ungefär en vecka började jag märka något konstigt - jag
        vaknade innan alarmet ringde. För någon som alltid har haft problem att
        komma ur sängen på morgonen var detta nästan chockerande. Min första
        tanke var att det måste vara en tillfällighet, men när det fortsatte
        hända började jag undra.
      </p>
      <div className="flex flex-col md:flex-row gap-6 mb-8" data-id="element-23">
        <div className="flex-1" data-id="element-24">
          <div className="relative" data-id="element-25">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sMdaHRFhspMz9EG99LdJ18/75b8fffd-5880-4e15-b68f-5421cb8d3e9a_min.webp?before=january&t=1" alt="Före jag började med Nourix" className="w-full h-auto rounded-lg filter grayscale" loading="eager" fetchpriority="high" onError={e => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = 'https://uploadthingy.s3.us-west-1.amazonaws.com/sMdaHRFhspMz9EG99LdJ18/75b8fffd-5880-4e15-b68f-5421cb8d3e9a_min.webp';
          }} data-id="element-26" />
            <div className="absolute top-0 left-0 bg-red-500 text-white py-1 px-3 rounded-br-lg rounded-tl-lg font-bold" data-id="element-27">
              FÖRE
            </div>
          </div>
          <p className="mt-3 text-center italic" data-id="element-28">
            Jag i januari, innan jag började med Nourix
          </p>
        </div>
        <div className="flex-1" data-id="element-29">
          <div className="relative" data-id="element-30">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/32CYLxdLrdn6hi2HFiyKhZ/image.png?after=threemonths&t=1" alt="Efter tre månader med Nourix - glad kvinna i bil visar upp Nourix-flaskan" className="w-full h-auto rounded-lg" loading="eager" fetchpriority="high" onError={e => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = 'https://uploadthingy.s3.us-west-1.amazonaws.com/32CYLxdLrdn6hi2HFiyKhZ/image.png';
          }} data-id="element-31" />
            <div className="absolute top-0 left-0 bg-green-500 text-white py-1 px-3 rounded-br-lg rounded-tl-lg font-bold" data-id="element-32">
              EFTER
            </div>
          </div>
          <p className="mt-3 text-center italic" data-id="element-33">
            Jag efter tre månader med Nourix
          </p>
        </div>
      </div>
      <p className="text-lg mb-4" data-id="element-34">
        Efter två veckor märkte jag att jag inte längre hade det intensiva
        sötsuget som brukade komma vid 15-tiden varje eftermiddag. Istället för
        att rusa till kaffeautomaten för en chokladbit kunde jag faktiskt
        fortsätta arbeta. Det var en liten förändring, men för mig var den
        enorm.
      </p>
      <div className="my-8" data-id="element-35">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-36">
          <div className="flex-1" data-id="element-37">
            <div className="relative" data-id="element-38">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8FSXuP4uxKz9onk1VDgEJx/sdasda.png?fullbody=before&t=1" alt="Före jag började med Nourix - helkroppsbild" className="w-full h-auto rounded-lg shadow-md filter grayscale" loading="eager" fetchpriority="high" onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = 'https://uploadthingy.s3.us-west-1.amazonaws.com/8FSXuP4uxKz9onk1VDgEJx/sdasda.png';
            }} data-id="element-39" />
              <div className="absolute top-0 left-0 bg-red-500 text-white py-1 px-3 rounded-br-lg rounded-tl-lg font-bold" data-id="element-40">
                FÖRE
              </div>
            </div>
            <p className="mt-3 text-center italic" data-id="element-41">
              Januari - innan jag började med Nourix
            </p>
          </div>
          <div className="flex-1" data-id="element-42">
            <div className="relative" data-id="element-43">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pBuSHmao4YX9ryLVzcUr4F/after.png?fullbody=after&t=1" alt="Efter tre månader med Nourix - helkroppsbild" className="w-full h-auto rounded-lg shadow-md" loading="eager" fetchpriority="high" onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = 'https://uploadthingy.s3.us-west-1.amazonaws.com/pBuSHmao4YX9ryLVzcUr4F/after.png';
            }} data-id="element-44" />
              <div className="absolute top-0 left-0 bg-green-500 text-white py-1 px-3 rounded-br-lg rounded-tl-lg font-bold" data-id="element-45">
                EFTER
              </div>
            </div>
            <p className="mt-3 text-center italic" data-id="element-46">
              April - efter tre månader med Nourix
            </p>
          </div>
        </div>
      </div>
      <p className="text-lg mb-4" data-id="element-47">
        Skillnaden var märkbar redan efter de första veckorna. Men det var inte
        bara vikten som förändrades - det var min energi, mitt humör och mitt
        förhållande till mat. Jag började sova bättre, vaknade utvilad och kände
        mig motiverad att röra på mig.
      </p>
      <p className="text-lg mb-4" data-id="element-48">
        Det mest överraskande var att jag inte längre hade samma intensiva
        sötsug som tidigare. Istället för att känna mig kontrollerad av
        sockerbegär kunde jag äta balanserat och njuta av maten utan att känna
        skuld eller tvång att äta mer.
      </p>
      <p className="text-lg mb-4" data-id="element-49">
        Efter tre månader hade jag gått ner 11 kilo, men vikten var faktiskt
        inte det viktigaste längre. Det som betydde mest var att jag äntligen
        kände mig fri från den ständiga kampen med mat och vikt.
      </p>
      <p className="text-lg mb-4" data-id="element-50">
        Min syster märkte förändringen innan jag berättade något. "Vad har hänt
        med dig?" frågade hon en kväll när vi sågs för middag. "Du ser... jag
        vet inte... lugnare ut?" Det var då jag berättade om Nourix för henne,
        och till min förvåning var hon inte skeptisk som jag förväntat mig. "Jag
        ser ju skillnaden", sa hon bara. "Inte bara i hur du ser ut, utan i hur
        du beter dig."
      </p>
      <div className="mt-10 text-center" data-id="element-51">
        <p className="text-lg mb-4 italic" data-id="element-52">
          Om du är nyfiken på Nourix efter att ha läst min berättelse, kan du ta
          deras korta quiz för att se om det kan passa dig.
        </p>
        <CTAButton text="Starta mitt personliga quiz →" data-id="element-53" />
      </div>
    </div>;
};